import "react-loading-skeleton/dist/skeleton.css";
import "../scss/style.scss";

import "./app/i18n"; // <<< --- IMPORT i18n CONFIGURATION EARLY ---

// Import store to ensure it's initialized
import { store } from "./app/store";

// Import hydration system
import "./app/hydrate";

// Import UI behavior scripts
import "./features/header/stickyHeader.js";
import "./features/home/home";
import "./features/about/about";

// Import footer accordion logic
import "./features/footer/footer.js";

/**
 * This is the main entry point for the JS application.
 * It's responsible for initializing the app and attaching event listeners.
 */
const initApp = (): void => {
  console.log("E-commerce application initialized");
};

// Initialize the app when DOM is ready
document.addEventListener("DOMContentLoaded", initApp);
